import QRCode from 'qrcode';

/**
 * Generate a readable ticket ID with MTU-OSH prefix followed by a unique number.
 * We rely on timestamp fragments plus a short random suffix to keep IDs unique.
 */
export const generateTicketId = () => {
  const timestampPart = Date.now().toString().slice(-5); // last 5 digits of timestamp
  const randomPart = Math.floor(Math.random() * 90 + 10); // 2-digit random number
  return `MTU-OSH${timestampPart}${randomPart}`;
};

/**
 * Generate QR code as data URL
 * @param {string} ticketId - The ticket ID to encode
 * @returns {Promise<string>} Data URL of the QR code image
 */
export const generateQRCode = async (ticketId) => {
  try {
    const qrCodeDataUrl = await QRCode.toDataURL(ticketId, {
      errorCorrectionLevel: 'M',
      type: 'image/png',
      quality: 0.92,
      margin: 1,
      color: {
        dark: '#000000',
        light: '#FFFFFF'
      },
      width: 300
    });
    return qrCodeDataUrl;
  } catch (error) {
    console.error('Error generating QR code:', error);
    throw error;
  }
};

/**
 * Generate QR code as base64 string (for email attachments)
 * @param {string} ticketId - The ticket ID to encode
 * @returns {Promise<string>} Base64 string of the QR code image
 */
export const generateQRCodeBase64 = async (ticketId) => {
  try {
    const qrCodeDataUrl = await generateQRCode(ticketId);
    // Remove data URL prefix to get base64 string
    return qrCodeDataUrl.split(',')[1];
  } catch (error) {
    console.error('Error generating QR code base64:', error);
    throw error;
  }
};

/**
 * Convert data URL to blob for email attachments
 * @param {string} dataUrl - Data URL of the image
 * @returns {Blob} Blob object
 */
export const dataURLtoBlob = (dataUrl) => {
  const arr = dataUrl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
};

